module.exports = __webpack_public_path__ + "static/media/power-switch.71ffd926.png";